
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tools/report-generator",
      function () {
        return require("private-next-pages/tools/report-generator.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tools/report-generator"])
      });
    }
  